import React from 'react'
import Axios from 'axios'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { ThemeProvider } from '@emotion/react'

import Merchant from 'pages/merchant'
import Story from 'pages/story'
import Product from 'pages/product'
import Collection from 'pages/collection'
import Default from 'pages/default'
import theme from './theme.json'

Axios.defaults.baseURL = process.env.REACT_APP_ROUTE_API_ADDRESS || window.ROUTE_API_ADDRESS

function App() {
  return (
    <div>
      <ThemeProvider theme={theme}>
        <Router>
          <Switch>
            <Route path="/" exact>
              <Default />
            </Route>
            <Route path="/story" exact>
              <Default type="story" />
            </Route>
            <Route path="/story/:storyId">
              <Story />
            </Route>
            <Route path="/product" exact>
              <Default type="product" />
            </Route>
            <Route path="/product/:productId">
              <Product />
            </Route>
            <Route path="/merchant" exact>
              <Default type="merchant" />
            </Route>
            <Route path="/merchant/:merchantId">
              <Merchant />
            </Route>
            <Route path="/collection" exact>
              <Default type="collection" />
            </Route>
            <Route path="/collection/:collectionId">
              <Collection />
            </Route>
            <Route path="/product_collection" exact>
              <Default type="collection" />
            </Route>
            <Route path="/product_collection/:collectionId">
              <Collection />
            </Route>
            <Route path="/featured_collection" exact>
              <Default type="collection" />
            </Route>
            <Route path="/featured_collection/:collectionId">
              <Collection />
            </Route>
          </Switch>
        </Router>
      </ThemeProvider>
    </div>
  )
}

export default App
